import request from '../utils/request'
import axios from 'axios'
import { API_BASE_URL } from '../utils/request'
import { getToken } from '../utils/auth'

export function getMallProducts(params) {
  return request({
    url: '/api/admin/mall/products',
    method: 'get',
    params
  })
}

export function getMallProductsPage(params) {
  return request({
    url: '/api/admin/mall/products/page',
    method: 'get',
    params
  })
}

export function getMallProduct(id) {
  return request({
    url: `/api/admin/mall/products/${id}`,
    method: 'get'
  })
}

export function createMallProduct(data) {
  return request({
    url: '/api/admin/mall/products',
    method: 'post',
    data
  })
}

export function updateMallProduct(id, data) {
  return request({
    url: `/api/admin/mall/products/${id}`,
    method: 'put',
    data
  })
}

export function publishMallProduct(id) {
  return request({
    url: `/api/admin/mall/products/${id}/publish`,
    method: 'post'
  })
}

export function offlineMallProduct(id) {
  return request({
    url: `/api/admin/mall/products/${id}/offline`,
    method: 'post'
  })
}

export function getMallMerchantTargets(params) {
  return request({
    url: '/api/admin/mall/merchant-targets',
    method: 'get',
    params
  })
}

export function getMallRecommendation() {
  return request({
    url: '/api/admin/mall/recommendation',
    method: 'get'
  })
}

export function saveMallRecommendation(data) {
  return request({
    url: '/api/admin/mall/recommendation',
    method: 'put',
    data
  })
}

export function getMallCategories(params) {
  return request({
    url: '/api/admin/mall/categories',
    method: 'get',
    params
  })
}

export function createMallCategory(data) {
  return request({
    url: '/api/admin/mall/categories',
    method: 'post',
    data
  })
}

export function updateMallCategory(id, data) {
  return request({
    url: `/api/admin/mall/categories/${id}`,
    method: 'put',
    data
  })
}

export function deleteMallCategory(id) {
  return request({
    url: `/api/admin/mall/categories/${id}`,
    method: 'delete'
  })
}

export function getMallOrders(params) {
  return request({
    url: '/api/admin/mall/orders',
    method: 'get',
    params
  })
}

export function getMallOrderDetail(id) {
  return request({
    url: `/api/admin/mall/orders/${id}`,
    method: 'get'
  })
}

export function shipMallOrder(id, data) {
  return request({
    url: `/api/admin/mall/orders/${id}/ship`,
    method: 'post',
    data
  })
}

export function refundMallOrder(id, data) {
  return request({
    url: `/api/admin/mall/orders/${id}/refund`,
    method: 'post',
    data
  })
}

export function approveMallOrderAfterSale(id, data) {
  return request({
    url: `/api/admin/mall/orders/${id}/after-sale/approve`,
    method: 'post',
    data
  })
}

export function rejectMallOrderAfterSale(id, data) {
  return request({
    url: `/api/admin/mall/orders/${id}/after-sale/reject`,
    method: 'post',
    data
  })
}

export function getMallProductFlowSummary(params) {
  return request({
    url: '/api/admin/mall/statistics/summary',
    method: 'get',
    params
  })
}

export function getMallProductRanking(params) {
  return request({
    url: '/api/admin/mall/statistics/product-ranking',
    method: 'get',
    params
  })
}

export function getMallProductFlowOrders(params) {
  return request({
    url: '/api/admin/mall/statistics/orders',
    method: 'get',
    params
  })
}

export function exportMallProductFlowOrders(params) {
  return axios({
    url: `${API_BASE_URL}/api/admin/mall/statistics/orders/export`,
    method: 'get',
    params,
    responseType: 'blob',
    headers: {
      Authorization: getToken() ? `Bearer ${getToken()}` : ''
    }
  })
}
